import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IndexedDbServiceService {
  private db: IDBDatabase | null = null;

  constructor() {
    this.initDatabase();
  }

  private initDatabase(): Promise<void> {
    const dbName = 'drmLicenseDB';
    const dbVersion = 1;

    return new Promise<void>((resolve, reject) => {
      const request = indexedDB.open(dbName, dbVersion);

      request.onerror = (event) => {
        console.error('IndexedDB error:', event);
        reject(event);
      };

      request.onsuccess = (event) => {
        this.db = request.result;
        resolve();
      };

      request.onupgradeneeded = (event) => {
        const db = request.result;
        db.createObjectStore('licenses', { keyPath: 'key' });
      };
    });
  }

 ensureDbInitialized(): Promise<void> {
    if (this.db) {
      return Promise.resolve();
    } else {
      return this.initDatabase();
    }
  }

  async saveLicense(key: string, license: any): Promise<void> {
    await this.ensureDbInitialized();
    const transaction = this.db.transaction(['licenses'], 'readwrite');
    const store = transaction.objectStore('licenses');
    store.put({ key, license });
  }

  async getLicense(key: string): Promise<any | null> {
    await this.ensureDbInitialized();
    const transaction = this.db.transaction(['licenses'], 'readonly');
    const store = transaction.objectStore('licenses');
    const request = store.get(key);

    return new Promise<ArrayBuffer | null>((resolve, reject) => {
      request.onsuccess = () => {
        resolve(request.result ? request.result.license : null);
      };

      request.onerror = (event) => {
        console.error('Error getting license from IndexedDB:', event);
        reject(event);
      };
    });
  }
}
